module.exports = __webpack_public_path__ + "static/media/satyamev.3e820ea3.png";